module.exports = __webpack_public_path__ + "img/138.cf275db0.jpg";